module.exports = __webpack_public_path__ + "images/drawings/bud_status_2.1d29501726e5cd1e35cff81e71830f59.png";